// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aE4sXbSHKgw0q_BkntDW {
  border: 1px solid #91D5FF;
  background-color: #E6F7FF;
  padding: 10px 20px;
  border-radius: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/admin-pages/Components/forms/styles.module.less"],"names":[],"mappings":"AACA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AAAF","sourcesContent":["\n.tip {\n  border: 1px solid #91D5FF;\n  background-color: #E6F7FF;\n  padding: 10px 20px;\n  border-radius: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tip": `aE4sXbSHKgw0q_BkntDW`
};
export default ___CSS_LOADER_EXPORT___;
